// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".section header[data-v-06ceb414]{margin-bottom:1.5rem}.section-issues li[data-v-06ceb414]{padding:.75rem 0}.section-issues li img[data-v-06ceb414]{margin:0 auto}.section-issues li h3[data-v-06ceb414]{font-size:1.375rem;margin:.75rem 0}.section-issues li p[data-v-06ceb414]{margin:0}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
